import type { Drawing } from "building-types/drawings/drawingTypes";
import {
  DrawingId,
  DrawingSize,
  DrawingScale,
  DrawingScaleMode,
  DrawingType,
} from "building-types/drawings/drawingTypesEnum";

export function drawingNew({
  id,
  catalogId,
  type,
  url = STATIC_MISSING_DRAWING_IMG_PATH,
  name = "New Drawing",
  prettyName,
  size = DrawingSize.INHERIT,
  drawingScale = DrawingScale.NTS,
  scaleMode = DrawingScaleMode.UNIFORM,
  scale = 1,
}: Partial<Drawing> & Pick<Drawing, "id" | "type" | "catalogId">): Drawing {
  return {
    catalogItemType: "DRAWING",
    id,
    catalogId,
    type,
    url,
    name,
    prettyName,
    size,
    scale,
    drawingScale,
    scaleMode,
  };
}
const isPrivateDrawing: {
  [K in DrawingId]?: boolean;
} = {
  [DrawingId.NULL]: true,
};

export const isProtectedDrawingType: {
  [K in DrawingType]?: boolean;
} = {
  [DrawingType.VOID]: true,
};

export const isFoundationDrawingType: {
  [K in DrawingType]?: boolean;
} = {
  [DrawingType.FOUNDATION]: true,
  [DrawingType.OTHER]: true,
  [DrawingType.VOID]: true,
};

export function isUserDrawing(drawingId: string) {
  return !DrawingId[drawingId];
}

export function isUserAccessibleDrawing(drawingId: string) {
  return !isPrivateDrawing[drawingId];
} // static path to asset used as a placeholder for drawings without a url referencing an s3 asset

export function isBuiltInDrawing(drawingId: string) {
  return drawingId === DrawingId.NULL || drawingId === DrawingId.NONE;
}

export const STATIC_MISSING_DRAWING_IMG_PATH = `/static/plans/details/detail_missing.png`;
